/**
 * 全局混合
 */
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { PostRes } from '@/store/pages/report/index.d';
import { dateFormate, fetchReportAfterRecovery } from '@/utils/report';
const Report = namespace('report');
import CommonMixin from '@/mixins/common.mixin';

@Component
export default class Level extends CommonMixin {
  @Report.Action('getDailyBusinessReport') private getDailyBusinessReport: any;
  @Report.Action('exportDailyBusinessReport') private exportDailyBusinessReport: any;
  @Report.Action('recoveryDailyBusinessReport') private recoveryDailyBusinessReport: any;
  
  public exportReport() {
    this.exportDailyBusinessReport({
      reportId: this.reportId, 
      level: this.level, 
      start_date: dateFormate(this.start),  
      end_date: dateFormate(this.end), 
      store_group_id: this.store_group_id
    });
  }
  public recovery() {
    this.recoveryDailyBusinessReport({reportId: this.reportId, level: this.level}).then((res: PostRes) => {
      this.fetchReport();
    });
  }
  public fetchReport() {
    fetchReportAfterRecovery(this, 'getDailyBusinessReport');
  }
}
